import { render } from "./LoadingIcon.vue?vue&type=template&id=97bf91b2&scoped=true"
import script from "./LoadingIcon.vue?vue&type=script&lang=js"
export * from "./LoadingIcon.vue?vue&type=script&lang=js"

import "./LoadingIcon.vue?vue&type=style&index=0&id=97bf91b2&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97bf91b2"]])

export default __exports__